import React from "react"
import {Paper, CircularProgress} from "@material-ui/core"

// Styles
import useStyles from "./styles"

type Props = {
    title: string
    number: number | null
    isLoading: boolean
    className?: string
}

const DoctorStatsPaper = (props: Props) => {
    const {title, number, isLoading, className} = props
    const styles = useStyles();

    const renderNumber = () => {
        if (isLoading && typeof number === "undefined") {
            return (
                <CircularProgress size={36}/>
            )
        }

        if (number === null) {
            return 0
        }

        return number
    }

    return (
        <Paper className={className ? `${styles.paper} ${className}` : styles.paper} elevation={3}>
            <h4 className={styles.paper_title}>
                {title}
            </h4>
            <span className={styles.paper_number}>
                {renderNumber()}
            </span>
        </Paper>
    )
}

export default DoctorStatsPaper
